document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-nav-toggle]');
  if (!toggle) return;

  var nav = toggle.closest('.site-nav');
  var isOpen = nav.classList.toggle('is-open');
  toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
});

function formatCartMoney(cents, format) {
  var value = (Number(cents || 0) / 100).toFixed(2);
  var withoutTrailingZeros = value.replace(/\.00$/, '');
  var formatted = format || '${{amount}}';

  return formatted
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withoutTrailingZeros)
    .replace(/\{\{\s*amount\s*\}\}/, value);
}

function setCartUpdating(form, isUpdating) {
  var status = form.querySelector('[data-cart-status]');
  var checkout = form.querySelector('[name="checkout"]');

  form.classList.toggle('is-updating', isUpdating);
  if (checkout) checkout.disabled = isUpdating;
  if (status) status.textContent = isUpdating ? 'Updating prices...' : '';
}

function reindexCartLines(form) {
  form.querySelectorAll('[data-cart-qty]').forEach(function (input, index) {
    input.setAttribute('data-cart-line', index + 1);
  });
}

document.addEventListener('input', function (event) {
  var qtyInput = event.target.closest('[data-cart-qty]');
  if (!qtyInput) return;

  var form = qtyInput.closest('[data-cart-form]');
  if (!form) return;

  var row = qtyInput.closest('[data-cart-row]');
  window.clearTimeout(form.cartUpdateTimer);
  form.cartUpdateTimer = window.setTimeout(function () {
    var line = Number(qtyInput.getAttribute('data-cart-line'));
    var quantity = Math.max(0, Number(qtyInput.value || 0));
    var moneyFormat = form.getAttribute('data-money-format');

    if (!line) return;
    if (row) row.classList.add('is-updating');
    setCartUpdating(form, true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function (cart) {
        var updatedItem = cart.items[line - 1];
        var linePrice = row ? row.querySelector('[data-cart-line-price]') : null;
        var total = form.querySelector('[data-cart-total]');
        var navCount = document.querySelector('.nav-cart-count');

        if (quantity === 0 && row) {
          row.remove();
        } else if (updatedItem && linePrice) {
          linePrice.textContent = formatCartMoney(updatedItem.final_line_price, moneyFormat);
        }
        if (total) total.textContent = formatCartMoney(cart.total_price, moneyFormat);
        if (navCount) navCount.textContent = cart.item_count;
        reindexCartLines(form);
        if (cart.item_count === 0) window.location.reload();
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (row) row.classList.remove('is-updating');
        setCartUpdating(form, false);
      });
  }, 450);
});
